import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LocalStorageService } from './localStorage.service';

@Injectable()
export class ThemeIconService {
  themeInfo: Subject<any> = new Subject();

  constructor(private localStorageService: LocalStorageService) {}

  themeUpdatedData(message: string) {
    this.themeInfo.next(message);
  }

  switchThemeMode(theme: string) {
    theme = theme == 'light' ? 'dark' : 'light';
    this.localStorageService.setItem('theme', theme);
    this.updateImage(theme);
    document.documentElement.setAttribute('data-theme', theme);
    if (window['APIMaticDevPortal'] && window['APIMaticDevPortal']['setThemeMode']) {
      window['APIMaticDevPortal'].setThemeMode(theme);
    }
    this.themeUpdatedData(theme);
    return theme;
  }
  updateImage(theme) {
    const masthead = document.querySelector('masthead-secondary') || document.querySelector('secondary-masthead');
    if (masthead) {
      const img = masthead.querySelector('img');
      if (img) {
        let imgSrc = img.getAttribute('src');
        if (imgSrc) {
          if (theme === 'light') {
            imgSrc = imgSrc.replace('dark', theme);
          }
          if (theme === 'dark') {
            imgSrc = imgSrc.replace('light', theme);
          }
        }
        img.setAttribute('src', imgSrc);
      }
    }
  }

  getDefaultSetting() {
    let theme = this.localStorageService.getItem('theme');
    theme = theme != undefined || theme != null ? theme : 'light';
    document.documentElement.setAttribute('data-theme', theme);
    return theme;
  }
}
